import { createTheme, alpha } from "@mui/material";

const sharedComponents = (mode) => ({
  MuiButton: {
    styleOverrides: {
      root: {
        borderRadius: 10,
        textTransform: "none",
        fontWeight: 600,
        transition: "transform 0.15s ease, box-shadow 0.2s ease",
        "&:active": { transform: "scale(0.97)" },
      },
    },
  },
  MuiListItemButton: {
    styleOverrides: {
      root: {
        borderRadius: 10,
        marginBottom: 4,
        transition: "background-color 0.2s ease, transform 0.15s ease",
        "&:hover": { transform: "translateX(2px)" },
      },
    },
  },
  MuiIconButton: {
    styleOverrides: {
      root: {
        transition: "transform 0.15s ease, background-color 0.2s ease",
        "&:hover": { transform: "scale(1.06)" },
        "&:active": { transform: "scale(0.94)" },
      },
    },
  },
  MuiPaper: {
    styleOverrides: {
      outlined: {
        borderRadius: 12,
      },
    },
  },
  MuiTableCell: {
    styleOverrides: {
      head: {
        fontWeight: 700,
        whiteSpace: "nowrap",
      },
      root: {
        paddingTop: 10,
        paddingBottom: 10,
      },
    },
  },
  MuiDrawer: {
    styleOverrides: {
      paper: {
        borderRight: "none",
        backgroundImage: "none",
        backgroundColor: mode === "dark" ? "#0E1620" : "#FFFFFF",
      },
    },
  },
  MuiAppBar: {
    styleOverrides: {
      root: {
        backgroundImage: "none",
        backdropFilter: "blur(10px)",
      },
    },
  },
  MuiMenu: {
    styleOverrides: {
      paper: {
        borderRadius: 12,
        marginTop: 8,
        boxShadow:
          mode === "dark"
            ? "0 12px 40px rgba(0,0,0,0.45)"
            : "0 12px 32px rgba(27,58,75,0.18)",
      },
    },
  },
  MuiTooltip: {
    defaultProps: { arrow: true },
  },
});

export const buildCadastrosMuiTheme = (mode) =>
  createTheme({
    typography: {
      fontFamily: '"Segoe UI", Roboto, Helvetica, Arial, sans-serif',
      button: { textTransform: "none", fontWeight: 600 },
    },
    shape: { borderRadius: 10 },
    components: sharedComponents(mode),
    palette: {
      mode,
      ...(mode === "light"
        ? {
            primary: { main: "#1B3A4B", light: "#2E5A70", dark: "#122830" },
            secondary: { main: "#E8A317", light: "#F0BC4A", dark: "#C4890F" },
            background: { default: "#F3F6F8", paper: "#FFFFFF" },
            divider: alpha("#1B3A4B", 0.12),
            text: {
              primary: "#152A36",
              secondary: alpha("#152A36", 0.72),
            },
          }
        : {
            primary: { main: "#5BA3BC", light: "#7FB8CC", dark: "#3D7F96" },
            secondary: { main: "#E8A317", light: "#F0BC4A", dark: "#C4890F" },
            background: { default: "#0B1520", paper: "#122230" },
            divider: alpha("#FFFFFF", 0.1),
            text: {
              primary: "#E8F0F4",
              secondary: alpha("#E8F0F4", 0.7),
            },
          }),
    },
  });
